import { render, staticRenderFns } from "./OrderListExchangeDeliveryAll.vue?vue&type=template&id=71edbaa6&scoped=true"
import script from "./OrderListExchangeDeliveryAll.vue?vue&type=script&lang=js"
export * from "./OrderListExchangeDeliveryAll.vue?vue&type=script&lang=js"
import style0 from "./OrderListExchangeDeliveryAll.vue?vue&type=style&index=0&id=71edbaa6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71edbaa6",
  null
  
)

export default component.exports